export default __webpack_public_path__ + "static/media/clinic.fd452c37.svg";